var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInvertCopy = function SvgInvertCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 1.5,
    clipPath: "url(#invert-copy_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.333 1.667H10c-2.357 0-3.536 0-4.268.789C5 3.244 5 4.513 5 7.052v.897c0 2.538 0 3.808.732 4.596s1.911.789 4.268.789h3.333c2.357 0 3.536 0 4.268-.789.732-.788.732-2.058.732-4.596v-.897c0-2.539 0-3.808-.732-4.596s-1.91-.789-4.268-.789Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.001 13.84c-.01 1.955-.09 3.014-.73 3.704-.733.79-1.912.79-4.269.79H6.67c-2.358 0-3.536 0-4.269-.79-.732-.79-.732-2.06-.732-4.602v-.899c0-2.542 0-3.812.732-4.602.535-.576 1.307-.732 2.602-.774"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "invert-copy_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgInvertCopy;